import React from 'react'
import styled from 'styled-components'
import Image from '../../../components/Image'

const Wrapper = styled.div`
  text-align: center;

  img {
    vertical-align: bottom;
    margin-bottom: 0;
  }
`

const ImageWidget = ({ container: Container, images, text }) => {
  return (
    <Container my={[35]}>
      <Wrapper>
        {images.widgets.map((image, i) => {
          const resource =
            image && image.crops && image.crops[0] && image.crops[0].src
          return (
            <Image key={`iw:${resource}:${i}`} resource={resource} alt={text} />
          )
        })}
      </Wrapper>
    </Container>
  )
}

export default ImageWidget
